import { getRpsLevel, RPS_EMPTY_COLOR, RpsRiskAxis } from "../model/rps-risk"

export const RPS_CELL_WIDTH = 52
export const RPS_GLOBAL_CELL_WIDTH = 88

interface Props {
  level: number | null
  axis?: RpsRiskAxis
  isGlobal?: boolean
  label: string
  onClick?: () => void
}

/** Case de niveau RPS commune a la matrice et au dashboard d'une fonction. */
export default function RpsRiskCell({ level, axis, isGlobal, label, onClick }: Props) {
  const item = getRpsLevel(level, axis)
  const background = item?.color ?? RPS_EMPTY_COLOR
  const className = `box-border flex w-full min-h-[36px] items-center justify-center rounded-[12px] px-[4px] text-center text-sm font-bold ${isGlobal ? "text-white" : ""} ${onClick ? "_hover transition-shadow hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" : ""}`
  const content = isGlobal ? item?.label : null
  const accessibleLabel = `${label} : ${item?.label ?? "Non défini"}`

  return onClick ? (
    <button type="button" className={className} style={{ background, border: "none", fontFamily: "inherit", cursor: "pointer" }} aria-label={accessibleLabel} onClick={(event) => { event.stopPropagation(); onClick() }}>
      {content}
    </button>
  ) : (
    <div className={className} style={{ background }} aria-label={accessibleLabel}>{content}</div>
  )
}
